import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import TownshipConfiguration from 'src/pages/Admin/TownshipConfiguration';
import {
  canAccessTownshipConfiguration,
  getTownshipConfigurationDeniedRedirect,
  isTownshipConfigurationTownshipAllowed
} from 'src/utils/townshipAdminAccess';

const TownshipConfigurationRoute = () => {
  const { townshipId } = useParams<{ townshipId: string }>();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  if (!canAccessTownshipConfiguration(userDetails)) {
    return (
      <Navigate
        to={getTownshipConfigurationDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  if (!isTownshipConfigurationTownshipAllowed(userDetails, townshipId)) {
    return (
      <Navigate
        to={getTownshipConfigurationDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  return <TownshipConfiguration />;
};

export default TownshipConfigurationRoute;
